const roles = [
    { "id": 1, "name": "Team Member" },
    { "id": 2, "name": "Team Leader" },
    { "id": 3, "name": "Stakeholder" }
]

export default {
    roles
}